import type { FeedPageType } from "@/features/feed/contract"

export const feedKeys = {
  all: ["feed"] as const,
  pages: (pageType: FeedPageType, handle: string, initialCursor: string, viewer: string) => [...feedKeys.all, pageType, handle, initialCursor, viewer] as const,
}
